import React from 'react';
import Select from "react-select";


export const customStyles = (onError) => ({
    control: (base, state) => ({
        ...base,
        boxShadow: state.isFocused && onError
            ? "0 0 0 3px rgba(255, 0, 0, 0.2)"
            : state.isFocused
                ? "0 0 0 3px rgba(128, 128, 128, 0.2)"
                : "none",

        borderColor: onError
            ? "red"
            : state.isFocused
                ? "grey"
                : "#ddd",

        "&:hover": {
            borderColor: onError ? "red" : "grey",
        },
    }),

    valueContainer: (base) => ({
        ...base,
        padding: "0 8px",
    }),

    input: (base) => ({
        ...base,
        boxShadow: "none",
    }),

    indicatorSeparator: () => ({
        display: "none",
    }),

    dropdownIndicator: (base) => ({
        ...base,
        padding: "4px",
    }),

    menu: (base) => ({
        ...base,
        marginTop: 4,
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    }),

    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#eee" : "white",
        color: "black",
        "&:active": {
            backgroundColor: "#ddd",
        },
    }),
});


const CustomSelect = (props) => (
    <Select
        {...props}
        styles={customStyles(props?.onError)}
    />
)

export default CustomSelect;